export const LOCAL_CART_STORAGE_KEY = 'polyshop_local_cart';
